import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { Popover } from '@onefootprint/ui';
import * as HoverCard from '@radix-ui/react-hover-card';
import { easeOut, motion } from 'framer-motion';
import { useState } from 'react';
import useMobileLayout from '@/hooks/use-mobile-layout';
type BaseHoverCardProps = {
  textTrigger: string;
  children: React.ReactNode;
  titleText?: string;
  titleIcon?: Icon;
};
const BaseHoverCard = t0 => {
  const $ = _c(37);
  const {
    textTrigger,
    children,
    titleText,
    titleIcon: TitleIcon
  } = t0;
  const isMobile = useMobileLayout();
  const [open, setOpen] = useState(false);
  if (isMobile) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = () => setOpen(false);
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== TitleIcon) {
      t2 = TitleIcon && <TitleIcon />;
      $[1] = TitleIcon;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== titleText) {
      t3 = titleText && <span className="text-label-2">{titleText}</span>;
      $[3] = titleText;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
      t4 = <div className="flex items-center gap-1">{t2}{t3}</div>;
      $[5] = t2;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== children || $[9] !== t4) {
      t5 = <div className="flex w-[458px] max-w-[calc(100vw-2rem)] max-h-[70dvh] overflow-y-auto flex-col gap-4 p-4">{t4}{children}</div>;
      $[8] = children;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== textTrigger) {
      t6 = <button type="button" className="inline-block -my-2 py-2 text-left underline text-label-2">{textTrigger}</button>;
      $[11] = textTrigger;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] !== open || $[14] !== t5 || $[15] !== t6) {
      t7 = <Popover side="bottom" controlledOpen={open} onControlledOpenChange={setOpen} onEscapeKeyDown={t1} content={t5}>{t6}</Popover>;
      $[13] = open;
      $[14] = t5;
      $[15] = t6;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    return t7;
  }
  let t1;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="absolute inset-[-8px]" />;
    $[17] = t1;
  } else {
    t1 = $[17];
  }
  let t2;
  if ($[18] !== textTrigger) {
    t2 = <HoverCard.Trigger className="relative inline-block cursor-default">{t1}<span className="relative z-10 underline text-label-2">{textTrigger}</span></HoverCard.Trigger>;
    $[18] = textTrigger;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      scale: 0.9
    };
    t4 = {
      opacity: 1,
      scale: 1
    };
    t5 = {
      duration: 0.1,
      ease: easeOut
    };
    t6 = {
      transformOrigin: "var(--radix-hover-card-content-transform-origin)"
    };
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t3 = $[20];
    t4 = $[21];
    t5 = $[22];
    t6 = $[23];
  }
  let t7;
  if ($[24] !== TitleIcon) {
    t7 = TitleIcon && <TitleIcon />;
    $[24] = TitleIcon;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== titleText) {
    t8 = titleText && <span className="text-label-2 whitespace-nowrap">{titleText}</span>;
    $[26] = titleText;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t7 || $[29] !== t8) {
    t9 = <div className="flex items-center gap-1">{t7}{t8}</div>;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== children || $[32] !== t9) {
    t10 = <HoverCard.Portal><HoverCard.Content side="bottom" sideOffset={4} align="start" collisionPadding={8} avoidCollisions={true} asChild={true}><motion.div className="z-10 flex flex-col gap-4 p-5 border border-solid rounded shadow-md border-tertiary bg-primary border-spacing-1 max-w-[458px] min-w-[380px]" initial={t3} animate={t4} transition={t5} style={t6}>{t9}{children}</motion.div></HoverCard.Content></HoverCard.Portal>;
    $[31] = children;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== t10 || $[35] !== t2) {
    t11 = <HoverCard.Root openDelay={0} closeDelay={0}>{t2}{t10}</HoverCard.Root>;
    $[34] = t10;
    $[35] = t2;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  return t11;
};
export default BaseHoverCard;